import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Serenity',
    url: 'https://tsdtys5.cn',
    description: '专业女性情趣用品信息平台，提供阴蒂夹使用指南、选购推荐与科普文章。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@serenity-wellness.com',
      availableLanguage: ['Chinese'],
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://tsdtys5.cn/' },
      { '@type': 'ListItem', position: 2, name: '关于我们' },
    ],
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('submitting');
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setFormStatus('success');
      form.reset();
      return;
    }

    formData.delete('phone_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9u0hklca23r0tr1ao30', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse error
      }

      const code = (parsed as { code?: string })?.code;
      const serverMsg =
        ((parsed as { meta?: { message?: string } })?.meta?.message) ||
        ((parsed as { message?: string })?.message) ||
        ((parsed as { meta?: { detail?: string } })?.meta?.detail) ||
        responseText;

      if (response.ok && code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else if (
        serverMsg.toLowerCase().includes('spam') ||
        serverMsg.toLowerCase().includes('form data is spam')
      ) {
        setFormError(serverMsg);
        setFormStatus('error');
      } else {
        setFormError(serverMsg || '提交失败，请稍后重试');
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      <ScrollToTop />
      <Navbar />

      <main className="pt-20">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { name: '首页', path: '/' },
              { name: '关于我们' },
            ]}
          />
        </div>

        {/* Hero */}
        <section className="relative w-full h-[300px] md:h-[380px] flex items-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=warm%20minimalist%20wellness%20lifestyle%20space%20with%20soft%20curtains%20gentle%20natural%20light%20serene%20atmosphere%20clean%20elegant%20interior%20with%20flowers%20and%20neutral%20textures%20peaceful%20composition&width=1800&height=700&seq=about-hero-01&orientation=landscape"
            alt="关于 Serenity"
            title="Serenity - 品牌故事"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/45 to-black/25"></div>
          <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
            <h1 className="font-heading text-3xl md:text-4xl font-semibold text-background-50 mb-3">
              关于 Serenity
            </h1>
            <p className="text-background-200 text-sm md:text-base max-w-xl">
              致力于为女性提供专业、私密、值得信赖的情趣用品信息平台
            </p>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <span className="text-xs text-primary-600 font-medium uppercase tracking-wider">Our Story</span>
                <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mt-2 mb-5">
                  以专业与温度，陪伴你的愉悦探索
                </h2>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                  Serenity 诞生于一个简单的信念：每一位女性都有权利了解并悦纳自己的身体。我们深知，在情趣用品领域，女性往往缺乏专业、安全、私密的信息获取渠道。因此，我们创建了这个平台，致力于为女性提供最全面、最专业的阴蒂夹科普与选购指导。
                </p>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                  我们的团队由性健康教育专家、产品测评师和经验丰富的编辑组成。每一篇内容都经过严格的审核流程，确保信息的准确性和可靠性。我们坚持只推荐经过严格筛选的优质产品。
                </p>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  我们相信，当女性充分了解自己的身体和需求时，她们能够做出更好的选择。Serenity 的使命，就是成为你这条探索之路上的贴心伙伴。
                </p>
              </div>
              <div className="aspect-[4/3] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=warm%20cozy%20workspace%20with%20soft%20textiles%20dried%20flowers%20and%20natural%20light%20feminine%20aesthetic%20minimalist%20design%20peaceful%20atmosphere%20creative%20studio%20vibe&width=800&height=600&seq=about-story-01&orientation=landscape"
                  alt="Serenity 工作空间"
                  title="Serenity 品牌故事"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Stats / Reputation */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
                值得信赖的口碑
              </h2>
              <p className="text-foreground-600 text-sm max-w-lg mx-auto">
                用数据说话，我们始终以用户满意为最高追求
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
              {[
                { number: '50万+', label: '月均访问用户' },
                { number: '5000+', label: '真实用户评价' },
                { number: '98.5%', label: '用户满意度' },
                { number: '200+', label: '精选科普文章' },
              ].map((stat, i) => (
                <div key={i} className="text-center p-6 bg-background-50 rounded-lg border border-background-200/70">
                  <div className="font-heading text-2xl md:text-3xl font-semibold text-accent-500 mb-2">
                    {stat.number}
                  </div>
                  <div className="text-sm text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
                我们的核心价值
              </h2>
              <p className="text-foreground-600 text-sm max-w-lg mx-auto">
                三大核心原则，贯穿我们做的每一件事
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                {
                  icon: 'ri-shield-check-line',
                  title: '专业严谨',
                  desc: '每篇文章均由性健康专家审核，产品推荐基于严格的评测标准，确保信息的准确性与权威性。',
                },
                {
                  icon: 'ri-lock-line',
                  title: '隐私至上',
                  desc: '我们深知隐私的重要性。平台不收集任何不必要的个人信息，所有浏览记录均严格保密。',
                },
                {
                  icon: 'ri-heart-line',
                  title: '温暖陪伴',
                  desc: '用温暖、平等、尊重的态度与每一位用户沟通，让探索身体的旅程不再孤单和羞怯。',
                },
              ].map((value, i) => (
                <div key={i} className="text-center p-8 bg-background-100 rounded-lg border border-background-200/70">
                  <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-primary-100 rounded-full">
                    <i className={`${value.icon} text-2xl text-primary-600`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">{value.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{value.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full max-w-2xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
                联系我们
              </h2>
              <p className="text-foreground-600 text-sm">
                有任何问题或建议？我们很乐意倾听你的声音
              </p>
            </div>

            <form
              onSubmit={handleSubmit}
              data-readdy-form
              className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8 space-y-5"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    姓名 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="contact-name"
                    name="name"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    邮箱 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="contact-email"
                    name="email"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  主题
                </label>
                <input
                  type="text"
                  id="contact-subject"
                  name="subject"
                  className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                  placeholder="请输入主题"
                />
              </div>

              <div>
                <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  留言内容 <span className="text-primary-500">*</span>
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                  placeholder="请输入您的留言内容（不超过500字）"
                ></textarea>
              </div>

              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hp-field"
              />

              <button
                type="submit"
                disabled={formStatus === 'submitting'}
                className="w-full bg-primary-500 hover:bg-primary-600 disabled:bg-primary-300 text-background-50 dark:text-foreground-950 font-medium py-3 rounded-lg transition-all duration-300 whitespace-nowrap"
              >
                {formStatus === 'submitting' ? '提交中...' : '发送留言'}
              </button>

              {formStatus === 'success' && (
                <div className="text-center text-sm text-green-600 bg-green-50 py-3 rounded-lg">
                  感谢您的留言！我们会尽快回复您。
                </div>
              )}
              {formStatus === 'error' && formError && (
                <div className="text-center text-sm text-red-600 bg-red-50 py-3 rounded-lg">
                  {formError}
                </div>
              )}
            </form>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}